import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TransactionSpinnerModule } from '@fmr-pr175919/fc-core-ui-lib';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { AchEnrollmentStoreModule } from './features/ach-enrollment/store/ach-enrollment-store.module';
import { DppEnrollmentStoreModule } from './features/dpp-enrollment/store/dpp-enrollment-store.module';
import { LayoutModule } from './layout/layout.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AchEnrollmentStoreModule,
        LayoutModule,
        StoreModule.forRoot(),
        EffectsModule.forRoot({}),
        StoreRouterConnectingModule.forRoot(),
        ErrorPageComponent,
        TransactionSpinnerModule,
        DppEnrollmentStoreModule,
        RouterModule.forRoot([], {
            useHash: true,
            scrollPositionRestoration: 'top',
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true,
        }),
    ],
    providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
    bootstrap: [AppComponent],
})
export class AppModule {}
